/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createImageToEntity } from '../fn/images/create-image-to-entity';
import { CreateImageToEntity$Params } from '../fn/images/create-image-to-entity';
import { deleteImage1 } from '../fn/images/delete-image-1';
import { DeleteImage1$Params } from '../fn/images/delete-image-1';
import { getImagesByTypeAndId } from '../fn/images/get-images-by-type-and-id';
import { GetImagesByTypeAndId$Params } from '../fn/images/get-images-by-type-and-id';
import { ImageResponse } from '../models/image-response';
import { updateImageProperties } from '../fn/images/update-image-properties';
import { UpdateImageProperties$Params } from '../fn/images/update-image-properties';


/**
 * Image upload and management endpoints. GET requires authentication only. POST, PUT, DELETE require PRODUCT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ImagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateImageProperties()` */
  static readonly UpdateImagePropertiesPath = '/images/{id}';

  /**
   * Update the requested image basic attributes.
   *
   * Update the requested image basic attributes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImageProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImageProperties$Response(params: UpdateImageProperties$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageResponse>> {
    const obs = updateImageProperties(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update the requested image basic attributes.
   *
   * Update the requested image basic attributes
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateImageProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImageProperties(params: UpdateImageProperties$Params, context?: HttpContext): Observable<ImageResponse> {
    const resp = this.updateImageProperties$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ImageResponse>): ImageResponse => r.body)
    );
  }

  /** Path part for operation `deleteImage1()` */
  static readonly DeleteImage1Path = '/images/{id}';

  /**
   * Delete an image by id.
   *
   * Delete image by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteImage1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage1$Response(params: DeleteImage1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteImage1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete an image by id.
   *
   * Delete image by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteImage1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage1(params: DeleteImage1$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteImage1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getImagesByTypeAndId()` */
  static readonly GetImagesByTypeAndIdPath = '/images';

  /**
   * Get images by refrence type and reference identifier.
   *
   * Finds and returns the saved images.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImagesByTypeAndId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImagesByTypeAndId$Response(params: GetImagesByTypeAndId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageResponse>>> {
    const obs = getImagesByTypeAndId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get images by refrence type and reference identifier.
   *
   * Finds and returns the saved images.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImagesByTypeAndId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImagesByTypeAndId(params: GetImagesByTypeAndId$Params, context?: HttpContext): Observable<Array<ImageResponse>> {
    const resp = this.getImagesByTypeAndId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ImageResponse>>): Array<ImageResponse> => r.body)
    );
  }

  /** Path part for operation `createImageToEntity()` */
  static readonly CreateImageToEntityPath = '/images';

  /**
   * Upload image to the referenced entity.
   *
   * Upload and saved the image to the referenced object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createImageToEntity()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createImageToEntity$Response(params?: CreateImageToEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageResponse>> {
    const obs = createImageToEntity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload image to the referenced entity.
   *
   * Upload and saved the image to the referenced object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createImageToEntity$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createImageToEntity(params?: CreateImageToEntity$Params, context?: HttpContext): Observable<ImageResponse> {
    const resp = this.createImageToEntity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ImageResponse>): ImageResponse => r.body)
    );
  }

}
